import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Header from "../../components/Header";
import WPButton from "../WPButton";
import WPHeading from "../WPHeading";
import FULL_SCREEN_ERROR_STRINGS from "./WPErrorFullPage.strings";

import {
  API_RESPONSE_CODE,
  HTTP_STATUS_CODE,
} from "../../constants/apiResponseCode.constants";
import { HOME_PATH } from "../../constants/global.constants";

import {
  accessDenied,
  appCrashed,
  maintenance,
  unauthorized,
} from "../../assets/illustrations";

import Footer from "../../common/footer/Footer";

import {
  getActiveLanguage,
  getContactUsUrlByLanguage,
} from "../../utils/Utils";

import "./WPErrorFullPage.scss";

const ERROR_PAGE_SCENE = {
  [HTTP_STATUS_CODE.UNAUTHORIZED]: unauthorized,
  [HTTP_STATUS_CODE.FORBIDDEN]: accessDenied,
  [HTTP_STATUS_CODE.SERVICE_UNAVAILABLE]: maintenance,
  [API_RESPONSE_CODE.APP_CRASH]: appCrashed,
};

const WPErrorFullPage = ({ errorCode = null }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const globalApiErrorCode = useSelector((state) => state.globalApiErrorCode);
  const currentErrorCode = errorCode ?? globalApiErrorCode;

  useEffect(() => {
    if (errorCode == null && globalApiErrorCode == null) {
      navigate(HOME_PATH, { replace: true });
    }
  }, [errorCode, globalApiErrorCode, navigate]);

  if (currentErrorCode == null) {
    return null;
  }

  const activeLanguage = getActiveLanguage(i18n);
  const contactUsUrl = getContactUsUrlByLanguage(activeLanguage);

  const handleContactUs = () => {
    window.open(contactUsUrl, "_blank");
  };

  const handleActionButtonClick = () => {
    if (currentErrorCode === HTTP_STATUS_CODE.UNAUTHORIZED) {
      window.location.reload();
      return;
    }

    if (currentErrorCode === HTTP_STATUS_CODE.FORBIDDEN) {
      navigate(HOME_PATH);
      return;
    }

    handleContactUs();
  };

  const fullScreenErrorStrings = FULL_SCREEN_ERROR_STRINGS(t);
  const { title, message, buttonText } =
    fullScreenErrorStrings[currentErrorCode];

  return (
    <div className="container-main">
      <Header disableActions />
      <div className="main-container">
        <div className="content-container">
          <div className="wavepro-fullpage-error-container">
            {ERROR_PAGE_SCENE[currentErrorCode] && (
              <img src={ERROR_PAGE_SCENE[currentErrorCode]} alt="" />
            )}
            <WPHeading type="default">{title}</WPHeading>
            <WPHeading
              className="message"
              secondary
              type="default"
              wrapContent={false}
            >
              {message}
            </WPHeading>
            <div className="error-page-button-container">
              <WPButton
                id="error-contact-us-btn"
                variant="outlined"
                onClick={handleActionButtonClick}
              >
                {buttonText}
              </WPButton>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default WPErrorFullPage;
